import { Component, OnInit } from '@angular/core';
import { PageTitleService } from '../../core/page-title/page-title.service';
import { fadeInAnimation } from "../../core/route-animation/route.animation";

@Component({
  selector: 'ms-blank',
  templateUrl: './blank.component.html',
  styleUrls: ['./blank.component.scss'],
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class BlankComponent implements OnInit {

  constructor(private pageTitleService: PageTitleService) {

    this.pageTitleService.setTitle("Blank");

  }

  ngOnInit() {

  }

}
